<template>
    <v-btn 
      class="mx-0"
      :small="small" 
      :light="light" 
      @click.prevent="pdfLabelsCall()"
      :loading="loading"
      :disabled="loading">
      <v-icon :small="small" class="mr-2">mdi-file-pdf</v-icon> TEXT LABELS
    </v-btn>
      <!-- <iframe id='pdfLabels' style='width:700px; height: 999px;'></iframe> -->
</template>

<script>
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  export default {
    data: () => ({
      loading: false,
      outputFields: ['classification'],
      output_fields: [],
      outputFieldsParams: [],
      valid: true,
      view: 'table',
      sort: 'full_name',
      title: 'LIST TITLE',
      subtitle: 'List description',
      pdf_artworks: []
    }),
    props: {
      light: Boolean,
      small: Boolean,
      item: Object,
      use_current_selection: Boolean
    },
    created () {
      // this.pdfLabels()
    },
 
    methods: {
      // o2ids (array,prop) {
      //   return array.map(a => a[prop])
      // },
      // ids2o (array) {
      //   var objs = Object.assign([], this.$store.state.artworks)
      //   var out = objs.filter(a => {
      //     // console.log(array.includes(a.id))
      //     return (array.includes(a.id))
      //   })
      //   return out
      // },
      pdfLabelsCall () {
          // console.log('pdfLabelsCall')
        this.loading = true;
        setTimeout(function () {
          setTimeout(function () {
            this.pdfLabels()
            this.loading = false
          }.bind(this),0)
        }.bind(this),500)
      },
      pdfLabels () {
        var output_fields = this.output_fields
        var use_current_selection = this.use_current_selection        
        function dynamicSort(property) {
          var sortOrder = 1;
          if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
          }
          return function (a,b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
          }
        }
        // console.log('labels small text')
        // console.log(this.item)
         if (this.item && this.item.artworks.length > 0) {
          this.pdf_artworks = this.item.artworks
        } else {
          // console.log(this.use_current_selection)
          if (use_current_selection == true) {
            // this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
            if (this.$store.state.currentSelection.length > 0) {
              this.pdf_artworks = Object.assign([], ids2o(this.$store.state.currentSelection)).sort(dynamicSort(this.sort))
            } else {
              this.pdf_artworks = Object.assign([], this.$store.state.artworks).sort(dynamicSort(this.sort))
            }
          } else {
            if (this.$store.state.filterResults) {
              var objs = this.ids2o(this.$store.state.filterResults)
              this.pdf_artworks = objs.sort(dynamicSort(this.sort))
            } else {
              this.pdf_artworks = Object.assign([], this.$store.state.artworks).sort(dynamicSort(this.sort))
            }
          }
        }
        var transformedULSData = []
        this.pdf_artworks.forEach(a => {

          var o = ''
          if (typeof(a) == 'number') {
            o = this.$store.state.artworks.find(f => f.id == a)
          } else {
            o = a
          }

          transformedULSData.push({
            "title": o.title,
            "full_name": o.full_name,
            "accession_number": o.accession_number,
            "production_date_new": o.production_date_new ? o.production_date_new : '',
            "dim": o.dim_f_json,
            "ownership": o.ownership
          })
        })
        // console.log(transformedULSData)
        // console.log('labels small text')

        const reportDate = () => new Date()

        const createDocumentDefinition = (reportDate, subHeading, ...contentParts) => {
          const baseDocDefinition = {
            pageSize: 'A4',
            pageMargins: [ 22, 55, 0, 0 ],
            info: {
              title: 'Text Labels A4',
              subject: 'Text Labels A4'
            },
            // defaultStyle: {
            //   font: 'HelveticaNeue'
            // },
            styles: {
              title: { fontSize: 9, bold: true, margin: [8,2,0,0], width: 150 },
              title2: { fontSize: 9, bold: true, margin: [8,2,0,25], width: 150 },
              artwork_title: { fontSize: 11, margin: [8,0,0,0], width: 150 },
            },
            // fonts: {
            //   HelveticaNeue: {
            //     normal: ['HelveticaNeue.ttc', 'HelveticaNeue-Regular'],
            //     bold: ['HelveticaNeue.ttc', 'HelveticaNeue-Bold'],
            //     italics: ['HelveticaNeue.ttc', 'HelveticaNeue-Italic'],
            //     bolditalics: ['HelveticaNeue.ttc', 'HelveticaNeue-BoldItalic']
            //   }
            // },
            content: [
              {
                columns: [
                ]
              }
            ]
          }
          const docDefinition = JSON.parse(JSON.stringify(baseDocDefinition))
          // docDefinition.footer = baseDocDefinition.footer
          docDefinition.content.push(...contentParts)
          return docDefinition
        }

        var rowData = function rowData (a) {
          var stack = {
            stack: [],
          };
          var title_and_year = `${a['title']}, ${a['production_date_new']}`

          switch (a['ownership']) {
          case '6':
            stack.stack.push({text: 'FRANCESCA VON HABSBURG', style: 'artwork_title'});
            stack.stack.push({text: 'PRIVATE ART COLLECTION', style: 'artwork_title'});
            break
          case '1':
            stack.stack.push({text: 'TBA21 COLLECTION', style: 'artwork_title'});
            break
          case '7':
            stack.stack.push({text: 'FRANCESCA VON HABSBURG', style: 'artwork_title'});
            stack.stack.push({text: 'PRIVATE DESIGN COLLECTION', style: 'artwork_title'});
            break
          case '10':
            stack.stack.push({text: 'PRIVATE ART COLLECTION MR', style: 'artwork_title'});
            break
          case 'de':
            stack.stack.push({text: 'DEACCESSION', style: 'artwork_title'});
            break
          // case '9 ':
          //   stack.stack.push({text: 'OLD MASTERS', style: 'artwork_title'});
          //   break
          default:
            stack.stack.push({text: 'OTHER', style: 'artwork_title'});
          }

          // stack.stack.push({text: 'FRANCESCA VON HABSBURG', style: 'artwork_title'});
          // stack.stack.push({text: 'PRIVATE COLLECTION', style: 'artwork_title'});
          stack.stack.push({text: a['accession_number'], style: 'artwork_title'});
          stack.stack.push({text: a['full_name'], style: 'artwork_title'});
          stack.stack.push({text: a['dim'], style: 'artwork_title'});
          return stack
        }

        var rowData2 = function rowData2 (a,c) {
          // if (c==1) {
          //   var x = 10
          //   var y = 0
          // } else {
          //   var x = 300
          //   var y = 0
          // }
          var stack = {
      			// absolutePosition: {x: x, y: y},
            stack: [],
          };
          var title_and_year = `${a['title']}, ${a['production_date_new']}`
          // if (c==2) {
          //   var style = 'artwork_title'
          // } else {
          //   var style = 'artwork_title'
          // }

          switch (a['ownership']) {
          case 6:
            stack.stack.push({text: 'FRANCESCA VON HABSBURG', style: 'title'});
            stack.stack.push({text: 'PRIVATE ART COLLECTION', style: 'title2'});
            break
          case 1:
            stack.stack.push({text: 'TBA21 COLLECTION', style: 'title2'});
            break
          case 7:
            stack.stack.push({text: 'FRANCESCA VON HABSBURG', style: 'title'});
            stack.stack.push({text: 'PRIVATE DESIGN COLLECTION', style: 'title2'});
            break
          case 10:
            stack.stack.push({text: 'PRIVATE ART COLLECTION MR', style: 'title2'});
            break
          case 'de':
            stack.stack.push({text: 'DEACCESSION', style: 'title2'});
            break
          // case '9 ':
          //   stack.stack.push({text: 'OLD MASTERS', style: 'title2'});
          //   break
          default:
            stack.stack.push({text: 'OTHER', style: 'title2'});
          }
          // stack.stack.push({text: 'FRANCESCA VON HABSBURG', style: 'title'});
          // stack.stack.push({text: 'PRIVATE COLLECTION', style: 'title2'});
          stack.stack.push({text: a['accession_number'], style: 'artwork_title'});
          stack.stack.push({text: a['full_name'], style: 'artwork_title'});
          stack.stack.push({text: title_and_year, style: 'artwork_title'});
          stack.stack.push({text: a['dim'], style: 'artwork_title'});
          return stack
        }

        makeUnderlyingLoanSummaryDoc()

        function makeUnderlyingLoanSummaryDoc () {
          var averyBody = function averyBody(dataRows) {
            var c = 1
            var rows = []
            var cols = []
            dataRows.forEach(function (row, index) {
              cols.push(rowData2(row,c))
              c = c+1
              if (dataRows.length == 1) {
                c=1
                rows.push(cols)
                cols = []
              } else {
                if (c == 3) {
                  c=1
                  rows.push(cols)
                  cols = []
                }
              }
            })
            return rows
          }
          var tableColumnWidths = [290,250]
          var tableData = {
            layout: 'noBorders',
            table: {
              heights: 192,
              dontBreakRows: true,
              widths: tableColumnWidths,
              body: averyBody(transformedULSData)
            }
          }
          var docDefinition = createDocumentDefinition(reportDate(), 'Summary', tableData)
          pdfMake.createPdf(docDefinition).download('A4-small-text-labels.pdf');
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/lists/LabelsSmallText.vue